<template>
  <a-modal
    :title="title"
    :visible="open"
    :confirm-loading="submitLoading"
    @ok="submitForm"
    @cancel="cancel"
  >
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback :label="$t('views.bizUser.resetPwd.newPassword')" prop="newPassword">
        <a-input-password v-model="form.newPassword" :placeholder="$t('views.bizUser.resetPwd.newPasswordPlaceholder')" :maxLength="20" />
      </a-form-model-item>
      <a-form-model-item has-feedback :label="$t('views.bizUser.resetPwd.confirmPassword')" prop="confirmPassword">
        <a-input-password v-model="form.confirmPassword" :placeholder="$t('views.bizUser.resetPwd.confirmPasswordPlaceholder')" :maxLength="20" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { resetPassword } from '@/api/biz/user'
export default {
  name: 'ResetPassword',
  props: {
  },
  data () {
    return {
      submitLoading: false,
      open: false,
      childrenDrawer: false,
      formLayout: 'horizontal',
      form: {
        userName: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
    }
  },
  computed: {
    title () {
      return this.$t('views.bizUser.resetPwd.title')
    },
    rules () {
      const vm = this
      const validateNewPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(vm.$t('views.bizUser.resetPwd.err.newPwdRequired')))
        } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9a-zA-Z]{6,12}$/.test(value)) {
          callback(new Error(vm.$t('views.bizUser.resetPwd.err.newPwdPattern')))
        } else {
          if (vm.form.confirmPassword !== '' && vm.$refs.form) {
            vm.$refs.form.validateField('confirmPassword')
          }
          callback()
        }
      }
      const validateConfirmPass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(vm.$t('views.bizUser.resetPwd.err.confirmRequired')))
        } else if (value !== vm.form.newPassword) {
          callback(new Error(vm.$t('views.bizUser.resetPwd.err.confirmMismatch')))
        } else {
          callback()
        }
      }
      return {
        newPassword: [
          { required: true, validator: validateNewPass, trigger: 'change' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPass, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: undefined,
        userName: undefined,
        newPassword: undefined,
        confirmPassword: undefined
      }
    },
    handleResetPwd (row) {
      this.form = {
        id: row.id,
        userName: row.userName
      }
      this.open = true
    },
    /** 重置密码按钮操作 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          resetPassword({ id: this.form.id, password: this.form.newPassword }).then(response => {
            this.$message.success(
              this.$t('views.bizUser.resetPwd.msg.success'),
              3
            )
            this.open = false
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
